<template>
    <div>
        <div class="row mt-2" style="background-color: #f7f7fc; padding: 10px 0px; border-top-left-radius: 1rem; border-top-right-radius: 1rem;">
          <div class="col-sm-12">
            <div class="input-group" style="height: 85%; width: 93%; float: left;">
              <input id="filter-text-box-current" data-test="filter-text-box-current" type="text" :placeholder="$t('search-users')" class="form-control border-0 shadow-sm" @input="onFilterTextBoxChanged()">
              <span class="input-group-text border-0 shadow-sm"><i class="fa fa-search"></i></span>
            </div>
            <span class="text-primary" style="cursor: pointer; float: right; width: 5%; padding-top: 9px;" @click="refreshFilterTextBox()">{{ $t('clear-search') }}</span>
          </div>
        </div>
        <b-overlay :show="busy" rounded="sm">
        <ag-grid-vue
            style="width: 100%; height: 500px; font-family: 'Nunito', sans-serif;"
            class="ag-theme-alpine text-center"
            rowSelection="single"
            :gridOptions="gridOptions"
            :frameworkComponents="frameworkComponents"
            :columnDefs="columnDefs"
            :pagination="true"
            paginationPageSize="30"
            :rowData="filteredNetworkMembers"
            @grid-ready="onGridReady"
        ></ag-grid-vue>

          <b-modal v-model="sendMessage.showModal" hide-header hide-footer>
            <CreateMessage :network="network" :user_id="sendMessage.selectedUserID" @user-message-sent-event="sendMessage.showModal = false" />
          </b-modal>
        </b-overlay>
    </div>
</template>
<script>
window.axios = require('axios');
import CreateMessage from '@/views/messages/CreateMessage.vue';
import moment from 'moment';
import BtnMessage from './BtnMessage.js';
import BtnFeatureMember from './BtnFeatureMember.js';
import BtnDeleteMember from './BtnDeleteMember.js';
import BtnAdminMember from './BtnAdminMember.js';
import BtnModeratorMember from './BtnModeratorMember.js';
import BtnContributorMember from './BtnContributorMember.js';
import BtnIndustryMember from './BtnIndustryMember.js';
import '@/lib/ag-grid';

export default {
  components: {
    CreateMessage,
  },
  filters: {
    date(val) {
      return val ? moment(val).format('YYYY-MM-DD') : '';
    },
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sendMessage: {
        showModal: false,
        selectedUserID: null,
      },
      filteredNetworkMembers: [],
      loadingInvites: true,
      processingResend: false,
      showJoinCard: false,
      instance: '',
    };
  },
  computed: {
    busy() {
      return this.processingResend || this.loadingInvites;
    },
  },
  watch: {
    isAdmin(newV) {
      newV = (this.filteredNetworkMembers.some(member => member.role_name === 'admin' && member.user_id === this.$auth.user.user_id))
            || (this.$auth.auth && this.$auth.hasRole('super-admin'));
      this.isAdmin = newV;
    },
  },
  beforeMount() {
    this.gridOptions = {
      defaultColDef: {
        width: 150,
        resizable: true,
        floatingFilter: true,
      },
      getRowNodeId: data => data.email,
    };
    this.onGridReady = () => {
      let filters = document.querySelectorAll('.ag-input-field-input');
      filters.forEach(filter => {
        filter.placeholder = this.$t('network.search');
      });
    };
    this.frameworkComponents = {
      btnCellRenderer: BtnMessage,
      btnFeatureCellRenderer: BtnFeatureMember,
      btnAdminCellRenderer: BtnAdminMember,
      btnModeratorCellRenderer: BtnModeratorMember,
      btnContributorCellRenderer: BtnContributorMember,
      btnIndustryCellRenderer: BtnIndustryMember,
      btnDeleteCellRenderer: BtnDeleteMember,
    };
    this.columnDefs = [
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.name'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'fullname',
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.auth.email'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-at"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'email',
        cellRenderer: (field) => {
          return `<a href="mailto:${field.value}">${field.value}</a>`;
        },
        minWidth: 200,
        flex: 1
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('network.auth.nameSuffix'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-diploma"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'name_suffix',
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('job-title'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-nurse"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'job_title',
        minWidth: 150,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: this.$t('workplace'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-briefcase"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'workplace',
        minWidth: 200,
        flex: 1,
      },
      {
        sortable: true,
        headerName: 'Admin',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-crown"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'role_name',
        cellRenderer: 'btnAdminCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.updateNetworkUserRole(field, field.role_name);
          },
        },
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        headerName: 'Moderator',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-cog"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'is_moderator',
        cellRenderer: 'btnModeratorCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.updateNetworkUserModerator(field, !field.is_moderator);
          },
        },
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        headerName: 'Featured',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-tag"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'is_featured',
        cellRenderer: 'btnFeatureCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.updateNetworkUserFeatured(field, !field.is_featured);
          },
        },
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        headerName: 'Contributor',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-photo-film"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'is_contributor',
        cellRenderer: 'btnContributorCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.updateNetworkUserContributor(field, !field.is_contributor);
          },
        },
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        headerName: 'Industry',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-user-tie"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'is_industry',
        cellRenderer: 'btnIndustryCellRenderer',
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        headerName: "Joined",
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-calendar-day"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: "joined",
        filter:'agDateColumnFilter',
        filterParams: {
          comparator:function (filterLocalDateAtMidnight, cellValue) {
            var dateAsString = cellValue.split(" ");
            if (dateAsString == null) return -1;
            var dateParts  = dateAsString[0].split("-");
            var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]) - 1, Number(dateParts[2]));

            if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
              return 0
            }

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            }

            if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            }
          },
          browserDatePicker: true,
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        cellRenderer: (field) => {
          return this.formatDate(field.value);
        },
        minWidth: 100,
        flex: 1,
      },
      {
        sortable: true,
        filter: true,
        filterParams: {
          filterOptions: ['contains'],
          suppressAndOrCondition: true,
          buttons: ['clear'],
        },
        headerName: 'Approved by',
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-check-to-slot"></i></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'approved_by',
        getQuickFilterText: () => '',
        minWidth: 150,
        flex: 1
      },
      {
        headerName: this.$t('network.member.message'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-messages"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'user_id',
        cellRenderer: 'btnCellRenderer',
        cellRendererParams: {
          clicked: field => {
            //this.showSendMessageModal(field.user_id);
            window.location = '/messages?user=' + field.user_id;
          },
        },
        minWidth: 100,
        flex: 1,
      },
      {
        headerName: this.$t('network.member.remove'),
        headerComponentParams: {
          template:
          '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <i class="fas fa-trash-alt"></i>&nbsp;<span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
          '</div>'
        },
        field: 'id',
        cellRenderer: 'btnDeleteCellRenderer',
        cellRendererParams: {
          clicked: field => {
            this.removeNetworkUser(field);
          },
        },
        minWidth: 100,
        flex: 1,
      },
    ];
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loadingInvites = true;
      if (this.$auth.auth) {
        this.$http
          .get('networks/' + this.network.slug + '/members')
          .then(resp => {
            this.loadingInvites = false;
            this.filteredNetworkMembers = resp.data.data;
            const isAdminUser = resp.data.data.some(member => member.role_name === 'admin' && member.user_id === this.$auth.user.user_id);
            const isSuperAdmin = this.$auth.auth && this.$auth.hasRole('super-admin');
            this.isAdmin = isAdminUser || isSuperAdmin;
            this.gridApi = this.gridOptions.api;
            this.gridOptions.columnApi.setColumnVisible('email', this.$auth.auth && this.$auth.hasRole('super-admin'));
            this.gridOptions.columnApi.setColumnVisible('name_suffix', this.$auth.auth && this.isAdmin);
            this.gridOptions.columnApi.setColumnVisible('job_title', this.$auth.auth && this.isAdmin);
            this.gridOptions.columnApi.setColumnVisible('workplace', this.$auth.auth && this.isAdmin);
            this.gridOptions.columnApi.setColumnVisible('id', this.network.can.remove_member);
            this.gridOptions.columnApi.setColumnVisible('is_moderator', this.network.moderation);
            this.gridOptions.columnApi.setColumnVisible('approved_by', this.network.moderation);
            this.gridColumnApi = this.gridOptions.columnApi;
        });
      }
    },
    formatDate(date) {
      date = new Date(date);
      return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' + date.getFullYear();
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(
        document.getElementById('filter-text-box-current').value
      );
    },
    refreshFilterTextBox() {
      this.gridApi.setQuickFilter(
        document.getElementById('filter-text-box-current').value = ''
      );
    },
    updateNetworkUserRole(member, roleName) {
      if (this.isAdmin) {
        let id = member.pivot ? member.pivot.id : member.pivot_id;
        let rowNode = this.gridOptions.api.getRowNode(this.gridOptions.getRowNodeId(member));
        let role = roleName == 'admin' ? 'member' : 'admin';
        rowNode.setDataValue('role_name', role);
        this.$swal.fire({
          text: role == 'admin' ? member.fullname + ' has been promoted to admin' : member.fullname + ' has been demoted to member',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 2000, // 2 seconds
          timerProgressBar: true,
        });
        this.$http.put('networks/' + this.network.slug + '/members/' + id, { role_name: role }).then(() => {
          if ((member.user_id === this.$auth.user.user_id) && role == 'member') {
            this.isAdmin = false;
          }
        });
        this.$bus.emit('network-admin-updated', { network: this.network, member: member });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    updateNetworkUserFeatured(member, is_featured) {
      if (this.isAdmin) {
        let id = member.pivot ? member.pivot.id : member.pivot_id;
        let rowNode = this.gridOptions.api.getRowNode(this.gridOptions.getRowNodeId(member));
        rowNode.setDataValue('is_featured', is_featured);
        this.$http.put('networks/' + this.network.slug + '/members/' + id, { is_featured });
        this.$swal.fire({
          text: is_featured == true ? member.fullname + ' is now a featured member' : member.fullname + ' is no longer a featured member',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    updateNetworkUserContributor(member, is_contributor) {
      if (this.isAdmin) {
        let id = member.pivot ? member.pivot.id : member.pivot_id;
        let rowNode = this.gridOptions.api.getRowNode(this.gridOptions.getRowNodeId(member));
        rowNode.setDataValue('is_contributor', is_contributor);
        this.$http.put('networks/' + this.network.slug + '/members/' + id, { is_contributor });
        this.$swal.fire({
          text: is_contributor == true ? member.fullname + ' is now a media contributor' : member.fullname + ' is no longer a media contributor',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    updateNetworkUserModerator(member, is_moderator) {
      if (this.isAdmin) {
        let id = member.pivot ? member.pivot.id : member.pivot_id;
        let rowNode = this.gridOptions.api.getRowNode(this.gridOptions.getRowNodeId(member));
        rowNode.setDataValue('is_moderator', is_moderator);
        this.$http.put('networks/' + this.network.slug + '/members/' + id, { is_moderator });
        this.$swal.fire({
          text: is_moderator == true ? member.fullname + ' is now a moderator' : member.fullname + ' is no longer a moderator',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
        this.$bus.emit('network-moderator-updated', { network: this.network, member: member });
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    removeNetworkUser(member) {
      if (this.isAdmin) {
        let msg = this.$t('network.member.doYouWantToRemoveTheMember') + '?';
        let id = member.pivot ? member.pivot.id : member.pivot_id;
        let action = () => {
          var selectedRowData = this.gridApi.getSelectedRows();
          this.gridApi.applyTransaction({ remove: selectedRowData });
          this.$http.delete('networks/' + this.network.slug + '/members/' + id);
        };
        this.showConfirmPrompt(action, msg);
      } else {
        this.$swal.fire({
          icon: 'error',
          title: "You don't have the permissions to do this.",
        });
      }
    },
    showSendMessageModal(user_id) {
      this.sendMessage.showModal = true;
      this.sendMessage.selectedUserID = user_id;
    },
  },
};
</script>
<style>
.ag-header-cell-label {
  justify-content: center;
  font-size: 19px;
  font-weight: 600;
  color: #5c6d80;
}
.ag-theme-alpine .ag-row {
  font-size: 15px;
}
.swal2-timer-progress-bar {
  background-color: #198754;
}
</style>